
      import OrganizeLine from './organize-line.vue'
      import type { App, Plugin } from 'vue'

      export const OrganizeLinePlugin: Plugin = {
        install(app: App) {
          app.component('OrganizeLine', OrganizeLine)
        },
      }
      export { OrganizeLine }
      